module.exports = __webpack_public_path__ + "media/images/div_lens/masonry-img-3-44818dfe37cde15c8e9abc63786bad10.png";